import React from "react";
import { getJ5Status } from "utils/j5Status";

export default function J5StatusBadge({ item, role = "dealer", compact = false, className = "" }) {
  const status = getJ5Status(item, role);

  return (
    <span
      dir="rtl"
      title={status.description}
      aria-label={`${status.label}. ${status.description}`}
      className={[
        "inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1 text-right text-xs font-semibold leading-5",
        status.className,
        className,
      ].join(" ")}
    >
      <span className="h-2 w-2 shrink-0 rounded-full bg-current" aria-hidden="true" />
      <span className={compact ? "truncate" : "whitespace-normal"}>{status.label}</span>
    </span>
  );
}
